/**
 * Application provider
 */
import React from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import 'moment/locale/ru';

import { ConfirmModal } from 'components/rfs-ui';

import { Tooltip } from 'react-tooltip';

import App from 'components/App';

import { setupStore } from 'store/store';

const history = createBrowserHistory({ getUserConfirmation: ConfirmModal.routerConfirm });
const store = setupStore(history);

export default function AppProvider() {
  return (
    <Provider store={store}>
      <App history={history} />
      <Tooltip id="app-tooltip" className="reactTooltip" classNameArrow="reactTooltipArrow" opacity={1} />
    </Provider>
  );
}
